import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Devices from "./pages/Devices";
import DevicePage from "./pages/DevicePage";
import Organizations from "./pages/Organizations";

// Компонент Layout для защищенных маршрутов
const ProtectedLayout = ({ children, isAuth }) => {
  if (!isAuth) {
    return <Navigate to="/login" />;
  }
  
  return (
    <>
      <Navbar isAuth={isAuth} />
      {children}
    </>
  );
};

const App = () => {
  const [isAuth, setIsAuth] = useState(() => {
    return !!localStorage.getItem('token');
  });

  // Функция для обновления состояния аутентификации
  const updateAuthStatus = () => {
    setIsAuth(!!localStorage.getItem('token'));
  };

  // Слушаем изменения в localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      updateAuthStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(updateAuthStatus, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Корневой маршрут перенаправляет на логин или устройства в зависимости от авторизации */}
        <Route 
          path="/" 
          element={isAuth ? <Navigate to="/devices" /> : <Navigate to="/login" />} 
        />
        
        <Route path="/login" element={<Login updateAuthStatus={updateAuthStatus} />} />
        
        {/* Защищенные маршруты с Layout */}
        <Route 
          path="/organizations" 
          element={
            <ProtectedLayout isAuth={isAuth}>
              <Organizations />
            </ProtectedLayout>
          } 
        />
        <Route 
          path="/devices" 
          element={
            <ProtectedLayout isAuth={isAuth}>
              <Devices />
            </ProtectedLayout>
          } 
        />
        
        {/* Публичный маршрут для DevicePage без Navbar */}
        <Route path="/devices/:id" element={<DevicePage />} />
        
        {/* Резервный маршрут */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;